// extracted by css-extract-rspack-plugin
export default {"root":"CEPsBgcBfnsww0Wx","titleRow":"VOt0JfKRPl8ee972","title":"Dapjj69nTjAsZIvY","subtitle":"ozdFBHV_F_UVmuDP"};